// display is populated in the loop below
const voices = [
  { display: 'todo', name: 'en-US-Studio-Q', gender: 'Male', type: 'Studio' },
  { display: 'todo', name: 'en-US-Studio-O', gender: 'Female', type: 'Studio' },

  { display: 'todo', name: 'en-US-Standard-A', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'en-US-Standard-B', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'en-US-Standard-D', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'en-US-Standard-C', gender: 'Female', type: 'Standard' },

  { display: 'todo', name: 'en-US-Journey-D', gender: 'Male', type: 'Journey' },
  { display: 'todo', name: 'en-US-Journey-F', gender: 'Female', type: 'Journey' },
  { display: 'todo', name: 'en-US-Journey-O', gender: 'Female', type: 'Journey' },

  { display: 'todo', name: 'es-US-Studio-B', gender: 'Male', type: 'Studio' },
  { display: 'todo', name: 'es-US-Neural2-B', gender: 'Male', type: 'Neural' },
  { display: 'todo', name: 'es-US-Neural2-C', gender: 'Male', type: 'Neural' },
  { display: 'todo', name: 'es-US-Neural2-A', gender: 'Female', type: 'Neural' },

  { display: 'todo', name: 'yue-HK-Standard-B', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'yue-HK-Standard-D', gender: 'Male', type: 'Standard' },
  { display: 'todo', name: 'yue-HK-Standard-A', gender: 'Female', type: 'Standard' },
  { display: 'todo', name: 'yue-HK-Standard-C', gender: 'Female', type: 'Standard' },

  // Requested from AJ
  { display: 'English (Australia) Female Standard C', name: 'en-AU-Standard-C', gender: 'todo', type: 'todo' },
  { display: 'English (Australia) Male Standard B', name: 'en-AU-Standard-B', gender: 'todo', type: 'todo' },
  { display: 'English (India) Female Standard E', name: 'en-IN-Standard-E', gender: 'todo', type: 'todo' },
  { display: 'English (India) Male Standard F', name: 'en-IN-Standard-F', gender: 'todo', type: 'todo' },
  { display: 'English (UK) Female Standard F', name: 'en-GB-Standard-F', gender: 'todo', type: 'todo' },
  { display: 'English (UK) Male Standard O', name: 'en-GB-Standard-O', gender: 'todo', type: 'todo' },
  { display: 'English (US) Female Standard E', name: 'en-US-Standard-E', gender: 'todo', type: 'todo' },
  { display: 'English (US) Female Standard F', name: 'en-US-Standard-F', gender: 'todo', type: 'todo' },
  { display: 'English (US) Female Standard G', name: 'en-US-Standard-G', gender: 'todo', type: 'todo' },
  { display: 'English (US) Female Standard H', name: 'en-US-Standard-H', gender: 'todo', type: 'todo' },
  { display: 'English (US) Male Standard I', name: 'en-US-Standard-I', gender: 'todo', type: 'todo' },
  { display: 'English (US) Male Standard J', name: 'en-US-Standard-J', gender: 'todo', type: 'todo' },
  { display: 'Japanese Female Standard B', name: 'ja-JP-Standard-B', gender: 'todo', type: 'todo' },
  { display: 'Japanese Male Standard C', name: 'ja-JP-Standard-C', gender: 'todo', type: 'todo' },
  { display: 'Mandarin Chinese Female Standard A', name: 'cmn-CN-Standard-A', gender: 'todo', type: 'todo' },
  { display: 'Mandarin Chinese Male Standard B', name: 'cmn-CN-Standard-B', gender: 'todo', type: 'todo' },
  { display: 'Russian Male Standard D', name: 'ru-RU-Standard-D', gender: 'todo', type: 'todo' },
  { display: 'Russian Female Standard E', name: 'ru-RU-Standard-E', gender: 'todo', type: 'todo' },
  { display: 'Korean Male Standard C', name: 'ko-KR-Standard-C', gender: 'todo', type: 'todo' },
  { display: 'Korean Female Standard A', name: 'ko-KR-Standard-A', gender: 'todo', type: 'todo' },
];

const localeNames = {
  en: 'English',
  es: 'Spanish',
  ja: 'Japanese',
  ru: 'Russian',
  cmn: 'Chinese (Mandarin)',
  yue: 'Chinese (Hong Kong)',
};

const languages = {};
for (let i = 0; i < voices.length; ++i) {
  const voice = voices[i];
  const locale = voice.name.split('-')[0];
  const display = voice.display;
  let type = voice.type;
  let gender = voice.gender;

  if (type === 'todo') {
    if (voice.name.includes('Journey')) {
      type = 'Journey';
    } else if (voice.name.includes('Neural')) {
      type = 'Neural';
    } else if (voice.name.includes('Studio')) {
      type = 'Studio';
    } else {
      type = 'Standard';
    }
    voice.type = type;
  }

  if (gender === 'todo' && voice.display !== 'todo') {
    if (display.includes('Female')) {
      gender = 'Female';
    } else if (display.includes('Male')) {
      gender = 'Male';
    }
    voice.gender = gender;
  }

  languages[locale] = languages[locale] || [];
  languages[locale][type] = languages[locale][type] || [];
  languages[locale][type][gender] = languages[locale][type][gender] || [];

  const localeName = localeNames[locale] || locale;

  const targetArray = languages[locale][type][gender];
  if (voice.display === 'todo') {
    voice.display = `${localeName} ${voice.gender} ${voice.type} ${targetArray.length + 1}`;
  }
  targetArray.push(voices[i]);
}

console.log(languages);
export default voices;



// WEBPACK FOOTER //
// ./src/utils/google-tts-voices.js